import { render } from "./switchList.vue?vue&type=template&id=380b2476"
import script from "./switchList.vue?vue&type=script&lang=js"
export * from "./switchList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__